module.exports = __webpack_public_path__ + "media/images/brand_icons/icon_bft-9badfb80fc94c938ba5d673ab263d021.svg";